import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import TableLayout from "../../../component/atoms/layout/table/tableLayout";
import TableTitle from "../../../component/atoms/text/table/tableTitle";
import Header from "../../../component/organisms/header";
import Sidebar from "../../../component/organisms/sidebar";
// import CommunityApi from "../../api/category.api";
import { toast } from "react-toastify";
import AddBtn from "../../../component/atoms/button/addBtn";
import DetailBtn from "../../../component/atoms/button/detailBtn";
import TableDelBtn from "../../../component/atoms/button/tableDelBtn";
import Table from "../../../component/atoms/layout/table/table";
import TableFilter from "../../../component/atoms/layout/table/tableFilter";
import TableSearchBtn from "../../../component/atoms/layout/table/tableSearchBtn";
import TableTop from "../../../component/atoms/layout/table/tableTop";
import Td from "../../../component/atoms/layout/table/td";
import Th from "../../../component/atoms/layout/table/th";
import Tr from "../../../component/atoms/layout/table/tr";
import TableText from "../../../component/atoms/text/table/tableText";
import Pagination from "../../../component/molecules/pagination";
import TableCount from "../../../component/molecules/tableCount";
import Modal from "../../../component/templates/Modal";
import { route } from "../../../router/route";
import { errorHandler } from "../../../util/errorHandler";
import { modalMsg } from "../../../util/modalMsg";
import { toastMsg } from "../../../util/toastMsg";
import CommunityApi from "../../../api/community.api";

const CommunityCategory = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();

  // mounted
  useEffect(() => {
    setKeyword(searchParams.get("keyword") ? searchParams.get("keyword") : "");
    getCategoryList();
  }, [location]);

  // ----- 목록 가져오기
  const page = useMemo(() => {
    return searchParams.get("page") ? searchParams.get("page") : 1;
  }, [searchParams]);

  const [pagination, setPagination] = useState({
    size: 10, // 한 페이지에 표시될 게시글 수
    rangeSize: 5, // 하단 페이지 사이즈
    totalCount: 0,
    totalPages: 0,
  });

  const [categoryList, setCategoryList] = useState([]);
  const [keyword, setKeyword] = useState("");

  const getCategoryList = async () => {
    try {
      const data = {
        keyword: searchParams.get("keyword"),
        page: searchParams.get("page"),
        size: pagination.size,
      };
      let responseData = (await CommunityApi.getCategory(data)).data.data;

      setCategoryList(
        responseData.content.map((item) => {
          return {
            ...item,
            checked: false,
          };
        })
      );
      setPagination({
        ...pagination,
        totalCount: responseData.totalCount ? responseData.totalCount : 0,
        totalPages: Math.ceil(responseData.totalCount / pagination.size),
      });
    } catch (error) {
      errorHandler(error);
    }
  };

  // ----- 활성/비활성
  const [filterOpen, setFilterOpen] = useState(-1);
  const [activationId, setActivationId] = useState(null);
  const [activation, setActivation] = useState(null);
  const [activationModalTitle, setActivationModalTitle] = useState("");
  const [activationModalOpen, setActivationModalOpen] = useState(false);

  const activationFunc = async () => {
    try {
      const data = {
        activation: activation,
      };
      await CommunityApi.updateActivation(activationId, data);
      toast(toastMsg.create);
      setFilterOpen(-1);
      setActivationModalOpen(false);
      getCategoryList();
    } catch (error) {
      errorHandler(error);
    }
  };

  // ----- 삭제
  const [delIdList, setDelIdList] = useState([]);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const isAllCheck = useMemo(() => {
    const checkedList = categoryList.filter((item) => item.checked);
    return (
      checkedList.length !== 0 && checkedList.length === categoryList.length
    );
  }, [categoryList]);

  const deleteFunc = async () => {
    try {
      const data = {
        ids: delIdList,
      };
      await CommunityApi.delcategory(data);
      toast(toastMsg.delete);
      setDeleteModalOpen(false);
      setDelIdList([]);
      getCategoryList();
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <>
      <Header />
      <MainLayout>
        <Sidebar />
        <TableLayout>
          <TableTitle>카테고리 관리</TableTitle>
          <TableTop>
            <TableCount text={"항목"} count={pagination.totalCount} />
            <TableSearchBtn>
              <AddBtn onClick={() => navigate(route.community_category_add)} />
            </TableSearchBtn>
          </TableTop>
          <Table>
            <colgroup>
              <col width="664px" />
              <col width="98px" />
              <col width="113px" />
              <col width="95px" />
              <col width="73px" />
            </colgroup>
            <thead>
              <Tr style={{ height: "40px", background: "#f2f4f5" }}>
                <Th style={{ paddingLeft: "20px" }}>
                  <TableText>카테고리명</TableText>
                </Th>
                <Th>
                  <TableText>게시글 수</TableText>
                </Th>
                <Th>
                  <TableText>활성 상태</TableText>
                </Th>
                <Th>
                  <TableText>삭제하기</TableText>
                </Th>
                <Th>
                  <TableText>상세보기</TableText>
                </Th>
              </Tr>
            </thead>
            <tbody>
              {categoryList.map((item, index) => {
                return (
                  <Tr
                    key={index}
                    style={{ height: "59px", background: "#fff" }}
                  >
                    <Td style={{ paddingLeft: "20px" }}>
                      <TableText
                        style={{
                          width: "397px",
                        }}
                      >
                        {item.title}
                      </TableText>
                    </Td>
                    <Td>
                      <TableText>{item.postCount}</TableText>
                    </Td>
                    <Td>
                      {item.id === 1 ? null : (
                        <TableFilter
                          style={{
                            width: "75px",
                          }}
                          onClick={() => {
                            filterOpen === index
                              ? setFilterOpen(-1)
                              : setFilterOpen(index);
                          }}
                          isOpen={filterOpen === index}
                          selectedValue={item.activation}
                          list={[
                            {
                              value: true,
                              title: "활성",
                              onClick: () => {
                                setActivationId(item.id);
                                setActivation(true);
                                setActivationModalTitle("활성화");
                                setActivationModalOpen(true);
                              },
                            },
                            {
                              value: false,
                              title: "비활성",
                              onClick: () => {
                                setActivationId(item.id);
                                setActivation(false);
                                setActivationModalTitle("비활성화");
                                setActivationModalOpen(true);
                              },
                            },
                          ]}
                        />
                      )}
                    </Td>
                    <Td>
                      {item.id === 1 ? null : (
                        <TableDelBtn
                          onClick={() => {
                            setCategoryList([...categoryList]);
                            const delList = [item];
                            setDelIdList(delList.map((item) => item.id));
                            setDeleteModalOpen(true);
                          }}
                        />
                      )}
                    </Td>
                    <Td>
                      {item.id === 1 ? null : (
                        <DetailBtn
                          onClick={() => {
                            navigate(
                              route.community_category_detail + `/${item.id}`
                            );
                          }}
                        />
                      )}
                    </Td>
                  </Tr>
                );
              })}
            </tbody>
          </Table>
          <Pagination
            route={route.community_category}
            queryString={`keyword=${encodeURIComponent(
              searchParams.get("keyword") || ""
            )}`}
            currentPage={page}
            totalPages={pagination.totalPages}
            rangeSize={pagination.rangeSize}
          />
        </TableLayout>
      </MainLayout>

      {activationModalOpen ? (
        <Modal
          title={`${activationModalTitle} 하시겠습니까?`}
          setModalOpen={setActivationModalOpen}
          onClick={() => {
            activationFunc();
          }}
        />
      ) : null}

      {deleteModalOpen ? (
        <Modal
          negative
          title={modalMsg.delete?.title}
          text={modalMsg.delete?.content}
          btnTitle={"삭제하기"}
          setModalOpen={setDeleteModalOpen}
          onClick={() => {
            deleteFunc();
          }}
        />
      ) : null}
    </>
  );
};
export default CommunityCategory;
